<template>
    <LexinKeyboardLangContent :layout_content="getLayout()" :lang_header="getHeader()" @add-to-search="addToSearchInput"></LexinKeyboardLangContent>
</template>
<script>

import LexinKeyboardLangContent from "@/components/LexinKeyboardLangContent.vue";

export default {
    props: [],
    components: {
        LexinKeyboardLangContent
    },

    methods: {
        getHeader(){
            return this.$t('message.keyboard-tamil');
        },
        getLayout() {
            let layout = {
                default: [
                    '\u0bcd',
                    '\u0b95 \u0b99 \u0b9a \u0b9e',
                    '\u0b9f \u0ba3 \u0ba4 \u0ba8',
                    '\u0baa \u0bae \u0baf \u0bb0',
                    '\u0bb2 \u0bb5 \u0bb4 \u0bb3 \u0bb1 \u0ba9',
                    '\u0b9c \u0bb6 \u0bb7 \u0bb8 \u0bb9',
                    '',
                    '\u0b85 \u0b86 \u0bbe \u0b87 \u0bbf \u0b88 \u0bc0 \u0b89 \u0bc1 \u0b8a \u0bc2',
                    '\u0b8e \u0bc6 \u0b8f \u0bc7 \u0b90 \u0bc8 \u0b92 \u0bca \u0b93 \u0bcb \u0b94 \u0bcc',
                    '',
                    '\u0bd7 \u0b82 \u0b83 \u0bd0',
                    '',
                    '\u0bf3 \u0bf4 \u0bf5 &nbsp; \u0bf9'
                ],
                shift: []
            };

            return layout;
        },

        addToSearchInput(value) {
            this.$emit('add-to-search', value);
        }
    }
}
</script>
